// Shared close semantics for the dispatcher b-modal forms: programmatic hides use the
// APP_TRIGGER so onHide handlers can tell them apart from user-initiated closes.
export const APP_TRIGGER = 'app';

export default {
  data() {
    return { closedEmitted: false };
  },
  methods: {
    emitClosed() {
      if (this.closedEmitted) return;
      this.closedEmitted = true;
      this.$emit('closed');
    },
    hideModal() {
      if (this.$refs.modal && typeof this.$refs.modal.hide === 'function') this.$refs.modal.hide(APP_TRIGGER);
      this.emitClosed();
    },
    onHidden() {
      this.emitClosed();
    },
    /** Blocks user-initiated closes (esc / backdrop / header ×) while a request is in flight; programmatic hides pass. */
    onHide(bvEvent) {
      if (!this.busy) return;
      if (bvEvent && bvEvent.trigger === APP_TRIGGER) return;
      if (bvEvent && typeof bvEvent.preventDefault === 'function') bvEvent.preventDefault();
    },
  },
};
